<script>
import Form from "form-backend-validation";
import pickBy from "lodash-es/pickBy";

export default {
  props: ["delay"],

  data() {
    return {
      form: null,
      redirecting: false
    };
  },

  computed: {
    isModal() {
      return (
        window.location.href.includes("&modal=1") ||
        window.location.href.includes("?modal=1")
      );
    },

    processing() {
      if (this.redirecting) {
        return true;
      }

      return this.form && this.form.processing;
    }
  },

  methods: {
    capitalize: value => {
      if (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    }
  },

  mounted() {
    window.addEventListener("pageshow", event => {
      const pageWasAccessedByNavigating =
        typeof window.performance != "undefined" &&
        window.performance.navigation.type === 2;

      if (event.persisted || pageWasAccessedByNavigating) {
        this.form = null;
        this.redirecting = false;
      }
    });
  },

  render() {
    return this.$scopedSlots.default({
      processing: this.processing,

      errors: () => {
        if (!this.form) {
          return {};
        }

        return this.form.errors.errors;
      },

      error: key => {
        if (!this.form) {
          return false;
        }

        var splitted = key.split("[");

        if (splitted.length > 1) {
          var parts = [];

          splitted.forEach(part => {
            if (part.substr(-1) === "]") {
              part = part.substring(0, part.length - 1);
            }

            parts.push(part);
          });

          key = parts.join(".");
        }

        return this.form.errors.has(key)
          ? this.capitalize(this.form.errors.first(key))
          : null;
      },

      onSubmit: $event => {
        this.$root.$emit("form-submitting");

        const $el =
          $event.target.tagName.toUpperCase() !== "FORM"
            ? $event.target.form
            : $event.target;

        var formData = new FormData($el);
        var formDataObj = {};

        formData.forEach((value, key) => {
          if (key.slice(-2) === "[]") {
            var newKey = key.substring(0, key.length - 2);

            formDataObj[newKey] = formDataObj[newKey]
              ? formDataObj[newKey]
              : [];

            value = value === "" ? null : value;

            return formDataObj[newKey].push(value);
          } else if (key.split("[").length > 2) {
            console.log(key);
          }

          formDataObj[key] = value === "" ? null : value;
        });

        formDataObj = pickBy(formDataObj, (value, key) => {
          return formDataObj[key + "_cropped"] === undefined;
        });

        this.form = new Form(formDataObj);

        var promise = this.form.post($el.action ? $el.action : window.location);

        promise
          .then(response => {
            if (response.data.status === 302) {
              this.redirecting = true;

              const delay = this.delay ? this.delay : 1;

              setTimeout(() => {
                if (this.isModal) {
                  window.parent.postMessage(
                    {
                      type: "redirect",
                      url: response.data.target_url
                    },
                    "*"
                  );
                } else {
                  window.location = response.data.target_url;
                }
              }, delay);
            }
          })
          .catch(response => {
            var errorMessages = document.querySelectorAll("p[error-message]");

            if (!this.isModal && errorMessages.length > 0) {
              errorMessages[0].scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest"
              });
            }
          });

        return promise;
      }
    });
  }
};
</script>
